export const parseStatus = (update_status) => {
  switch (update_status) {
    case 'UPDATED':
    case 'Atualizado':
      return {
        color: '#03e36a',
        status: 'Atualizado',
        text: 'Plataforma com os dados mais atuais disponibilizados pelo cliente.',
      }
    case 'UPDATING':
    case 'Atualizando':
      return {
        color: '#2c67e6',
        status: 'Atualizando',
        text: 'Atualizando, por favor aguarde alguns minutos.',
      }
    case 'SCHEDULED':
    case 'Agendado':
      return {
        color: '#ffe200',
        status: 'Agendado',
        text: 'A atualização ocorrerá no horário agendado.',
      }
    case 'OUTDATED':
    case 'Desatualizado':
      return {
        color: '#F54336',
        status: 'Desatualizado',
        text: 'Falha na coleta de dados. Iremos verificar.',
      }
    case 'Integrando':
      return {
        color: '#2c67e6',
        status: 'Integrando',
        text: 'Integrando.',
      }
    default:
      return {
        color: '',
        status: '',
        text: '',
      }
  }
}
